<div class="modal fade auth-modal" id="create-note" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="d-flex flex-row justify-content-between mt-3 mb-2 px-3">
                    <span class="modal-title">{{title}}</span>
                    <i class="fas fa-times modal-close" data-dismiss="modal" (click)="clearData()"></i>
                </div>
                <div class="horizontal-line mb-3"></div>
                <div class="d-flex flex-column mx-3">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="noteTitle" placeholder="Title">
                    <textarea class="form-control form-control-sm mt-3" rows="12" [(ngModel)]="noteText" placeholder="Description"></textarea>
                </div>
                <div class="d-flex flex-row justify-content-end mt-4 mx-3 mb-3">
                    <button class="btn btn-cancel mr-2" data-dismiss="modal" (click)="clearData()">Cancel</button>
                    <button class="btn btn-theme" [disabled]="noteText.length < 5 || noteTitle.length < 3 || saveBtn" (click)="createOrUpdateNote()">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>